enum TypeServices {
    Quiosque = 1,
    Piscina = 2,
    Academia = 3,
    Quadras = 4,
    Saloes = 5,
    Escolinhas = 6,
    Cowokings = 7,
}

export { TypeServices };



// WEBPACK FOOTER //
// ./src/utils/types.ts